<template>
	<div class="flex-centerize flex-column p-6">
		<h2 class="mb-3">Report this email</h2>
		<AppRadioButton v-model="reportSelection" :choices="reportEmailTypes">
			<template v-slot:label="{ item }">
				<div class="label">
					{{ item.title }}<span class="ml-1 sub-label">{{ item.subTitle }}</span>
				</div>
			</template>
		</AppRadioButton>
		<PrimaryButton :loading="isLoading" :disabled="isLoading || successfulClick" @click="submit">Submit</PrimaryButton>
	</div>
</template>

<script>
import api from '@/api';
import ErrorHandlingService from '@/utils/error-handling-service';
const shouldReportEmailValues = [3, 4];
export default {
	name: 'ReportPlyMailEmail',
	props: {
		b64: { type: String, required: true },
		noSpam: { type: Boolean, required: false, default: false },
	},
	data() {
		return {
			reportSelection: 1,
			isLoading: false,
			successfulClick: false,
		};
	},
	methods: {
		async submit() {
			this.isLoading = true;
			try {
				await api.reportUnsubscribeEmailRequest(this.b64, this.reportEmailTypesMap[this.reportSelection].title);
				if (!this.noSpam && shouldReportEmailValues.includes(this.reportSelection)) {
					await api.reportSpamEmailRequest(this.b64);
					this.$toast.success(`${this.successMessage}, we also reported this email as spam`, { timeout: 10000 });
				} else {
					this.$toast.success(this.successMessage, { timeout: 10000 });
				}
				this.successfulClick = true;
			} catch (error) {
				console.error('Failed to report email', error);
				this.$toast.error(ErrorHandlingService.extractErrorMessage(error) || 'Failed to report email');
			} finally {
				this.isLoading = false;
			}
		},
	},
	computed: {
		reportEmailTypes() {
			const options = [
				{ value: 1, title: "I don't want to receive these emails" },
				{ value: 2, title: 'I never signed up for this mailing list' },
				{ value: 3, title: 'These emails contain inappropriate content' },
				{ value: 4, title: 'These emails are spam and should be reported' },
			];
			if (this.noSpam) {
				options.splice(2, 2);
			}
			return options;
		},
		reportEmailTypesMap() {
			return this.reportEmailTypes.reduce((acc, item) => {
				acc[item.value] = item;
				return acc;
			}, {});
		},
		successMessage() {
			return "We've let the sender know you wish to be excluded from these emails. Note: since this email is not part of a mailing list, you are not unsubscribed automatically - it depends on the sender to remove you.";
		},
	},
};
</script>

<style scoped lang="scss"></style>
